import { customFetch } from '#/services/customFetch'
import type { BlogPost } from '../types/blog.types'

export async function getBlogBySlug(slug: string): Promise<BlogPost> {
  return customFetch<BlogPost>(`/student/blogs/${encodeURIComponent(slug)}`)
}
